import { render } from "./PlayActivityTableMobile.vue?vue&type=template&id=50c4bb31&scoped=true"
import script from "./PlayActivityTableMobile.vue?vue&type=script&lang=js"
export * from "./PlayActivityTableMobile.vue?vue&type=script&lang=js"

import "./PlayActivityTableMobile.vue?vue&type=style&index=0&id=50c4bb31&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c4bb31"]])

export default __exports__